<template>
    <div class="flex uppercase text-2xs text-center">
        <div class="w-full" v-for="(weekday, index) in dayLabels" :key="index">
            <div v-if="weekday === deliveryDayName" class="leading-snug">
                {{ $t('CALENDAR_HEADER_DELIVERY_DAY') }}
                <img class="mx-auto h-1 mb-2" src="@/assets/images/decoration/arrow-down-black.png">
            </div>

            <div v-else-if="weekday === cutOffDayName" class="leading-snug">
                {{ $t('CALENDAR_HEADER_NO_MORE', { time: getCutoffHours }) }}
                <img class="mx-auto h-1 mb-2" src="@/assets/images/decoration/arrow-down-black.png">
            </div>
        </div>
    </div>
</template>

<script>
import { enGB, enUS, de, deAT, nl } from 'date-fns/locale';
import { mapGetters } from 'vuex';
import format from 'date-fns/format';
import addDays from 'date-fns/addDays';

const locales = {
    'en-GB': enGB,
    'en-US': enUS,
    'de': de,
    'de-AT': deAT,
    'nl': nl,
};

export default {
    name: 'CalendarHeader',
    computed: {
        ...mapGetters({
            deliveries: 'scheduledOrder/getDeliveries',
        }),
        getCutoffHours() {
            const deliveryDayIndex = this.dayLabels.findIndex((item) => this.deliveryDayName === item);
            const cutoffDayIndex = this.dayLabels.findIndex((item) => this.cutOffDayName === item);
            return deliveryDayIndex - cutoffDayIndex === 1 ? '10am' : '12pm';
        },
        cutOffDayName() {
            return this.firstDelivery?.cut_off_shift_day_name || this.firstDelivery?.cut_off_day_name;
        },
        deliveryDayName() {
            return this.firstDelivery?.shift_delivery_day_name || this.firstDelivery?.delivery_day_name;
        },
        firstDelivery() {
            return this.deliveries.find((item) => item.delivery_scheduled || item.shift_delivery_date);
        },
    },
    data() {
        return {
            dayLabels: [],
        };
    },
    methods: {
        getDayLabels() {
            const startOfWeek = new Date('2021-07-05');
            this.dayLabels = [0, 1, 2, 3, 4, 5, 6].map((index) => {
                const date = addDays(startOfWeek, index);
                return format(date, 'EEEE', { locale: locales[process.env.VUE_APP_DATE_LOCALE] });
            });
        },
    },
    mounted() {
        this.getDayLabels();
    },
};
</script>

<style lang="scss" scoped>
    .calendar-header {
        @media (max-width: 768px) {
            width: 360px;
            margin: 0 auto;
        }
    }
</style>
